module.exports = __webpack_public_path__ + "img/item-9(1920).7a7807a9.jpg";